import { Environment, generateEmptyApi } from '@environment';

const customFrontendModules = {
  'work-with-us': () => import('../custom-modules/work-with-us.component').then(m => m.WorkWithUsComponent),
  'work-with-us-page': () =>
    import('../custom-modules/work-with-us-page.component').then(m => m.WorkWithUsPageComponent)
};

export const environment: Environment = {
  api: generateEmptyApi(),
  appType: 'cdp',
  siteName: 'cinemalive Releasing',
  appHasOnlyMovies: false,
  copyrightMsg: '',
  customPageParams: {
    headerFixed: true,
    headerSMsearchCollapse: true,
    headerSMsearchActive: true,
    channelVideoAutoplay: true,
    channelVideoEmbed: true
  },
  placeholderData: {
    // movie: 'clifford-the-big-red-dog',
    // performancesGroup: true,
    // nearestCities: true,
    // streamingLinks: true
  },
  logosConfig: {
    footer: {
      logoUrl: 'https://cdnstatic.usheru.com/img/channels/cinemalive.usheru.com/footer-image.png'
    }
  },
  customFrontendModules: customFrontendModules
};
